module.exports = __webpack_public_path__ + "static/img/naniungo-menu-projects.4fffed6e.jpg";